import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'

const ToogleGallery360 = () => {
  const [toggle, setToggle] = useState('360')
  const dispatch = useDispatch()

  function change360() {
    if (toggle !== '360') {
      document.getElementById('toggle-gallery').classList.toggle('active')
      document.getElementById('toggle-360').classList.toggle('active')
      setToggle('360')
      dispatch({ type: 'TOGGLE_GALLERY_360/360' })
    }
  }
  function changeGallery() {
    if (toggle !== 'Gallery') {
      document.getElementById('toggle-gallery').classList.toggle('active')
      document.getElementById('toggle-360').classList.toggle('active')
      setToggle('Gallery')
      dispatch({ type: 'TOGGLE_GALLERY_360/GALLERY' })
    }
  }

  return (
    <Container>
      <div
        value="toggle-360"
        onClick={() => change360()}
        id="toggle-360"
        className="active"
      >
        <svg
          width="20"
          height="13"
          viewBox="0 0 20 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.3 0 0 2.15 0 5C0 7.45 3.19 9.38 7.71 9.88L7.29 10.29C7.19627 10.383 7.12188 10.4936 7.07111 10.6154C7.02034 10.7373 6.9942 10.868 6.9942 11C6.9942 11.132 7.02034 11.2627 7.07111 11.3846C7.12188 11.5064 7.19627 11.617 7.29 11.71C7.38296 11.8037 7.49356 11.8781 7.61542 11.9289C7.73728 11.9797 7.86799 12.0058 8 12.0058C8.13201 12.0058 8.26272 11.9797 8.38458 11.9289C8.50644 11.8781 8.61704 11.8037 8.71 11.71L10.71 9.71C10.801 9.6149 10.8724 9.50275 10.92 9.38C11.02 9.13654 11.02 8.86346 10.92 8.62C10.8724 8.49725 10.801 8.3851 10.71 8.29L8.71 6.29C8.5217 6.1017 8.2663 5.99591 8 5.99591C7.7337 5.99591 7.4783 6.1017 7.29 6.29C7.1017 6.4783 6.99591 6.7337 6.99591 7C6.99591 7.2663 7.1017 7.5217 7.29 7.71L7.41 7.82C4 7.34 2 6 2 5C2 3.78 5.12 2 10 2C14.88 2 18 3.78 18 5C18 5.83 16.55 7 13.79 7.6C13.6594 7.62503 13.535 7.67587 13.4243 7.74954C13.3135 7.82321 13.2186 7.91824 13.145 8.02906C13.0715 8.13987 13.0207 8.26425 12.9958 8.39491C12.9709 8.52557 12.9724 8.65989 13 8.79C13.0273 8.91884 13.0798 9.04101 13.1544 9.14951C13.2291 9.25801 13.3244 9.35069 13.435 9.42224C13.5456 9.49379 13.6692 9.54279 13.7988 9.56643C13.9283 9.59007 14.0613 9.58788 14.19 9.56C17.84 8.76 20 7.06 20 5C20 2.15 15.7 0 10 0Z"
            fill="black"
          />
        </svg>
        <span>360°</span>
      </div>
      <div
        value="toggle-gallery"
        onClick={() => changeGallery()}
        id="toggle-gallery"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.0003 11.4998V3.1665C14.0003 2.50346 13.7369 1.86758 13.2681 1.39874C12.7993 0.929896 12.1634 0.666504 11.5003 0.666504H3.16699C2.50395 0.666504 1.86807 0.929896 1.39923 1.39874C0.930384 1.86758 0.666992 2.50346 0.666992 3.1665V11.4998C0.666992 12.1629 0.930384 12.7988 1.39923 13.2676C1.86807 13.7364 2.50395 13.9998 3.16699 13.9998H11.5003C12.1634 13.9998 12.7993 13.7364 13.2681 13.2676C13.7369 12.7988 14.0003 12.1629 14.0003 11.4998ZM2.33366 3.1665C2.33366 2.94549 2.42146 2.73353 2.57774 2.57725C2.73402 2.42097 2.94598 2.33317 3.16699 2.33317H11.5003C11.7213 2.33317 11.9333 2.42097 12.0896 2.57725C12.2459 2.73353 12.3337 2.94549 12.3337 3.1665V6.79984L11.4337 5.8915C11.0336 5.49141 10.4911 5.26659 9.92533 5.2665C9.35993 5.2684 8.81803 5.49295 8.41699 5.8915L7.65866 6.64984L6.98366 5.97484C6.52695 5.52545 5.91189 5.2736 5.27116 5.2736C4.63043 5.2736 4.01537 5.52545 3.55866 5.97484L2.33366 7.20817V3.1665ZM2.43366 11.8748C2.3694 11.7602 2.33501 11.6312 2.33366 11.4998V9.55817L4.73366 7.15817C4.80412 7.08737 4.88788 7.03119 4.98012 6.99285C5.07236 6.95451 5.17127 6.93478 5.27116 6.93478C5.37105 6.93478 5.46995 6.95451 5.5622 6.99285C5.65444 7.03119 5.73819 7.08737 5.80866 7.15817L6.50033 7.83317L2.43366 11.8748ZM9.60033 7.07484C9.64145 7.02965 9.69166 6.99366 9.74767 6.96925C9.80369 6.94483 9.86423 6.93254 9.92533 6.93317C9.98642 6.93254 10.047 6.94483 10.103 6.96925C10.159 6.99366 10.2092 7.02965 10.2503 7.07484L12.3337 9.14984V11.4998C12.3337 11.7209 12.2459 11.9328 12.0896 12.0891C11.9333 12.2454 11.7213 12.3332 11.5003 12.3332H4.33366L9.60033 7.07484ZM16.5003 3.99984C16.2793 3.99984 16.0674 4.08764 15.9111 4.24392C15.7548 4.4002 15.667 4.61216 15.667 4.83317V13.1665C15.667 13.8295 15.4036 14.4654 14.9348 14.9343C14.4659 15.4031 13.83 15.6665 13.167 15.6665H4.83366C4.61265 15.6665 4.40068 15.7543 4.2444 15.9106C4.08812 16.0669 4.00033 16.2788 4.00033 16.4998C4.00033 16.7209 4.08812 16.9328 4.2444 17.0891C4.40068 17.2454 4.61265 17.3332 4.83366 17.3332H13.167C14.2721 17.3332 15.3319 16.8942 16.1133 16.1128C16.8947 15.3314 17.3337 14.2716 17.3337 13.1665V4.83317C17.3337 4.61216 17.2459 4.4002 17.0896 4.24392C16.9333 4.08764 16.7213 3.99984 16.5003 3.99984Z"
            fill="black"
          />
        </svg>
        <span>Galeria</span>
      </div>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 2rem;
  grid-gap: ${rem(16)};
  gap: ${rem(16)};
  border-bottom: 1px solid #f8f8f9;
  cursor: pointer;

  div {
    height: ${rem(40)};
    width: 100%;
    margin: ${rem(16)} 0;
    background-color: #f8f8f9;
    border-radius: ${rem(20)};
    text-align: center;
    padding-top: 0.5em;
  }

  div svg {
    margin-right: ${rem(10)};
  }

  div.active {
    background-color: #000;
    color: #fff;
  }

  div.active svg path {
    fill: #fff;
  }
`

export default ToogleGallery360
